import React from "react";
import Logo from "../img/logo.png";
import Avatar from "../img/avatar.png";
import {
  RiShoppingCartLine,
  RiAddCircleFill,
  RiLogoutBoxRLine,
} from "react-icons/ri";

import { motion } from "framer-motion";
import { Link } from "react-router-dom";

import { getAuth, signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import { app } from "../firebase.config";
import { useStateValue } from "../context/StateProvider";
import { actionType } from "../context/reducer";
import { useState } from "react";

const Header = () => {
  const firebaseAuth = getAuth(app);
  const provider = new GoogleAuthProvider();

  const [{ user, cartShow, cartItems }, dispatch] = useStateValue();

  const [isMenu, setIsMenu] = useState(false);

  const login = async () => {
    if (!user) {
      const {
        user: { refreshToken, providerData },
      } = await signInWithPopup(firebaseAuth, provider);
      dispatch({
        type: actionType.SET_USER,
        user: providerData[0],
      });

      localStorage.setItem("user", JSON.stringify(providerData[0]));
    } else {
      setIsMenu(!isMenu);
    }
  };

  const logout = () => {
    setIsMenu(false);
    localStorage.clear();

    dispatch({
      type: actionType.SET_USER,
      useState: null,
    });
  };

  const showCart = () => {
    dispatch({
      type: actionType.SET_CART_SHOW,
      cartShow: !cartShow,
    });
  };

  return (
    <div className="fixed z-50 w-screen h-auto md:p-6 md:px-16 p-3 px-4 bg-primary">
      {/* desktop & tablet */}
      <div className="hidden md:flex w-full h-full items-center justify-between">
        <Link to="/" className="flex items-center gap-2 cursor-pointer">
          <img src={Logo} className="w-8 object-cover" alt="logo" />
          <p className=" text-headingColor text-xl font-bold">Restaurant</p>
        </Link>

        <div className=" flex items-center gap-8">
          <motion.ul
            initial={{ opacity: 0, x: -200 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -200 }}
            className=" flex items-center gap-8 font-medium "
          >
            <li className="text-base text-textColor hover:text-headingColor transition-all duration-100 ease-in-out cursor-pointer">
              <a href="/">Home</a>
            </li>
            <li className="text-base text-textColor hover:text-headingColor transition-all duration-100 ease-in-out cursor-pointer">
              Menu
            </li>
            <li className="text-base text-textColor hover:text-headingColor transition-all duration-100 ease-in-out cursor-pointer">
              About Us
            </li>
            <li className="text-base text-textColor hover:text-headingColor transition-all duration-100 ease-in-out cursor-pointer">
              Service
            </li>
          </motion.ul>

          <div
            className=" relative flex items-center justify-center"
            onClick={showCart}
          >
            <RiShoppingCartLine className=" text-textColor text-xl cursor-pointer" />
            {cartItems && cartItems.length > 0 && (
              <div className=" w-4 h-4 absolute -top-2 -right-3 rounded-full bg-cartNumBg flex items-center justify-center">
                <p className=" text-xs text-white font-semibold">
                  {cartItems.length}
                </p>
              </div>
            )}
          </div>

          <div className=" relative">
            <motion.img
              whileTap={{ scale: 0.6 }}
              src={user ? user.photoURL : Avatar}
              className=" w-10 min-w-[40px] h-10 min-h-[40px] cursor-pointer drop-shadow-xl rounded-full"
              alt="userprofile"
              onClick={login}
            />

            {isMenu && (
              <motion.div
                initial={{ opacity: 0, scale: 0.6 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.6 }}
                className=" w-40 bg-gray-50 shadow-xl rounded-lg flex flex-col absolute top-12 right-0"
              >
                {user && user.email === "leodavincii97@gmail.com" && (
                  <Link to={"/createItem"}>
                    <p
                      className=" px-4 py-2 flex items-center gap-3 cursor-pointer hover:bg-slate-200 transition-all duration-100 ease-in-out text-textColor text-base"
                      onClick={() => setIsMenu(false)}
                    >
                      New Item <RiAddCircleFill />
                    </p>
                  </Link>
                )}

                <p
                  className=" px-4 py-2 flex items-center gap-3 cursor-pointer hover:bg-slate-200 transition-all duration-100 ease-in-out text-textColor text-base"
                  onClick={logout}
                >
                  Logout <RiLogoutBoxRLine />
                </p>
              </motion.div>
            )}
          </div>
        </div>
      </div>

      {/* mobile */}
      <div className="flex items-center justify-between md:hidden w-full h-full p-4">
        <div
          className=" relative flex items-center justify-center"
          onClick={showCart}
        >
          <RiShoppingCartLine className=" text-textColor text-xl cursor-pointer" />
          {cartItems && cartItems.length > 0 && (
            <div className=" w-4 h-4 absolute -top-2 -right-3 rounded-full bg-cartNumBg flex items-center justify-center">
              <p className=" text-xs text-white font-semibold">
                {cartItems.length}
              </p>
            </div>
          )}
        </div>

        <Link to="/" className="flex items-center gap-2 cursor-pointer">
          <img src={Logo} className="w-8 object-cover" alt="logo" />
          <p className=" text-headingColor text-xl font-bold">Restaurant</p>
        </Link>

        <div className=" relative">
          <motion.img
            whileTap={{ scale: 0.6 }}
            src={user ? user.photoURL : Avatar}
            className=" w-10 min-w-[40px] h-10 min-h-[40px] cursor-pointer drop-shadow-xl rounded-full"
            alt="userprofile"
            onClick={login}
          />

          {isMenu && (
            <motion.div
              initial={{ opacity: 0, scale: 0.6 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.6 }}
              className=" w-40 bg-gray-50 shadow-xl rounded-lg flex flex-col absolute top-12 right-0"
            >
              {user && user.email === "leodavincii97@gmail.com" && (
                <Link to={"/createItem"}>
                  <p
                    className=" px-4 py-2 flex items-center gap-3 cursor-pointer hover:bg-slate-100 transition-all duration-100 ease-in-out text-textColor text-base"
                    onClick={() => setIsMenu(false)}
                  >
                    New Item <RiAddCircleFill />
                  </p>
                </Link>
              )}

              <ul className=" flex flex-col ">
                <li
                  className="text-base text-textColor px-4 py-2 hover:bg-slate-100 transition-all duration-100 ease-in-out cursor-pointer"
                  onClick={() => setIsMenu(false)}
                >
                  <a href="/">Home</a>
                </li>
                <li
                  className="text-base text-textColor px-4 py-2 hover:bg-slate-100 transition-all duration-100 ease-in-out cursor-pointer"
                  onClick={() => setIsMenu(false)}
                >
                  Menu
                </li>
                <li
                  className="text-base text-textColor px-4 py-2 hover:bg-slate-100 transition-all duration-100 ease-in-out cursor-pointer"
                  onClick={() => setIsMenu(false)}
                >
                  About Us
                </li>
                <li
                  className="text-base text-textColor px-4 py-2 hover:bg-slate-100 transition-all duration-100 ease-in-out cursor-pointer"
                  onClick={() => setIsMenu(false)}
                >
                  Service
                </li>
              </ul>

              <p
                className=" px-4 py-2 bg-slate-200 m-2 rounded-lg flex items-center justify-center gap-3 cursor-pointer hover:bg-slate-100 transition-all duration-100 ease-in-out text-textColor text-base"
                onClick={logout}
              >
                Logout <RiLogoutBoxRLine />
              </p>
            </motion.div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Header;
